import"core-js/modules/es.object.keys.js";import{isString,isObject,isArray}from"../type-validators";/**
 * Checks empty values for arrays,objects and strings.
 *
 * @param {object | Array | string} value
 */var isEmpty=function(a){return isString(a)&&0===a.length||(isObject(a)||isArray(a))&&0===Object.keys(a).length};export{isEmpty};